/*
 * Primeira tela apos o login: a primeira a que o perfil da acesso.
 * So o Administrador tem acesso irrestrito — antes havia atalhos por
 * tipo de conta que mandavam o usuario para telas que o perfil dele
 * nao concedia.
 */
export const getDefaultRoute = user => {
  const permissions = user?.permissions || {};
  const isAdmin = user?.profile === "admin";
  const hasPermission = key => isAdmin || permissions[key] === true;

  // O Mural vem primeiro: e a tela pensada para ser a porta de entrada.
  if (hasPermission("mural.view")) return "/";
  if (hasPermission("tickets.view")) return "/tickets";
  if (hasPermission("dashboard.view")) return "/painel";
  if (hasPermission("contacts.view")) return "/contacts";
  if (hasPermission("quickAnswers.view")) return "/quickAnswers";
  if (hasPermission("scheduledMessages.view") || hasPermission("campaigns.view")) return "/campaigns-schedules";
  if (hasPermission("connections.view")) return "/connections";
  if (hasPermission("integrations.view") || hasPermission("glpi.view") || hasPermission("whatsapp_provider.view") || hasPermission("knowledge.manage")) return "/integrations";
  if (hasPermission("queues.view")) return "/queues";
  if (hasPermission("users.view")) return "/users";
  if (hasPermission("profiles.manage")) return "/profiles";
  if (
    hasPermission("settings.view") ||
    hasPermission("settings.manage") ||
    hasPermission("settings.categories") ||
    hasPermission("settings.categories.view") ||
    hasPermission("settings.closing_reasons") ||
    hasPermission("settings.closing_reasons.view") ||
    hasPermission("settings.satisfaction") ||
    hasPermission("settings.satisfaction.view") ||
    hasPermission("tags.view") ||
    hasPermission("settings.ura") ||
    hasPermission("settings.forms") ||
    hasPermission("settings.audit_logs")
  ) {
    return "/settings";
  }

  return "/tickets";
};
